import InquiryForm from "@/components/InquiryForm";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28 pb-12">
        <div className="eyebrow text-[var(--pine)] mb-5">Get in touch</div>
        <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] max-w-3xl">
          Drop us a line.<br/>
          <span className="text-[var(--clay)]">We answer quickly.</span>
        </h1>
        <p className="text-[var(--ink-soft)] mt-6 max-w-xl leading-relaxed">
          Tell us roughly when you're coming, what you're curious about, how many of you there are — and we'll come back with a plan and a price.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-7 border border-[var(--border)] bg-white p-8 sm:p-10">
          <InquiryForm />
        </div>
        <div className="md:col-span-5 space-y-8">
          <ContactItem
            icon={<Mail size={18} />}
            label="Email"
            value="rigapartyweekend@rigapartyweekend.eu"
            href="mailto:rigapartyweekend@rigapartyweekend.eu"
          />
          <ContactItem
            icon={<Phone size={18} />}
            label="Phone / WhatsApp"
            value="+371 2772 6344"
            href="https://wa.me/37127726344?text=Hi%20Riga%20Party%20Weekend%2C%20I%27d%20like%20to%20know%20more%20about%20your%20tours."
          />
          <ContactItem icon={<MapPin size={18} />} label="Office" value="Balasta dambis 11, Riga" />
          <div className="border-t border-[var(--border)] pt-8" data-testid="contact-hours">
            <div className="eyebrow text-[var(--pine)] mb-3">When we're around</div>
            <p className="font-display text-3xl sm:text-4xl leading-none text-[var(--ink)]">
              24/7
            </p>
            <p className="text-[var(--ink-soft)] text-sm mt-3 leading-relaxed">
              Message us any time — we'll get back to you as soon as we can.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

function ContactItem({ icon, label, value, href }) {
  const content = (
    <>
      <div className="eyebrow text-[var(--ink-soft)] mb-2 flex items-center gap-2">{icon}{label}</div>
      <div className="font-display-light text-xl">{value}</div>
    </>
  );
  if (href) {
    return (
      <a
        href={href}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
        className="block group transition-colors hover:text-[var(--pine)]"
        data-testid={`contact-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
      >
        {content}
      </a>
    );
  }
  return <div>{content}</div>;
}
